import React, { Component } from "react";
import TableWithLoadingWrapper from "./tableWithLoadingWrapper";

export default class GenericTableOnRowOnClick extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <TableWithLoadingWrapper
        rowSelection={this.props.rowSelection}
        pagination={this.props.pagination}
        columns={this.props.columns}
        dataSource={this.props.dataSource}
        onRow={(record, rowIndex) => {

          return {
            onClick: (event) => {
              if (this.props.allTransactionsTable) {
                return;
              }
              if (this.props.onClickEvent)
                this.props.onClickEvent(record);
            },
          };
        }}
        expandableConfig={this.props.expandableConfig}
        tableLayout={this.props.tableLayout}
        style={{ width: "100%", ...this.props.style }}
        components={this.props.components}
        scroll={{
          x: 600,
        }}
        loading={this.props.loading || false}
        footer={this.props.footer || undefined}
        onChange={this.props.onChange || undefined}
      />
    );
  }
}
